import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function DeliverablesSection() {
  const items = ['Mapa de síntomas para diferenciar: restricción real vs mala semana vs técnico vs fatiga.', 'Checklist de higiene (qué arreglar y qué NO tocar).', 'Plan de 7 días “safe-mode” (acciones seguras + señales a medir).', 'Árbol de decisiones: “si pasa X → haces Y”.', 'Scripts listos para soporte, apelación, comunidad y marcas.', 'Calendario anti-pánico de 14 días para volver a ritmo normal sin recaer.'];
  return <section className="py-24" data-id="element-51">
      <div className="mx-auto max-w-4xl px-6" data-id="element-52">
        <div className="mb-12 text-center" data-id="element-53">
          <h2 className="text-3xl font-bold tracking-tight text-white md:text-4xl" data-id="element-54">
            Qué obtienes (exacto)
          </h2>
          <p className="mt-4 text-sm uppercase tracking-widest text-gray-500" data-id="element-55">
            Formato: PDF descargable (lectura rápida + uso repetible)
          </p>
        </div>

        <div className="grid gap-4" data-id="element-56">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 rounded-lg border border-white/5 bg-white/5 p-4" data-id="element-57">
              <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green-500/20" data-id="element-58">
                <Check className="h-4 w-4 text-green-500" data-id="element-59" />
              </div>
              <p className="text-lg text-gray-200" data-id="element-60">{item}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}